import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home/Home';
import Estatuto from './pages/Estatuto/Estatuto';
import Diretoria from './pages/Diretoria/Diretoria';
import Historia from './pages/Historia/Historia';
import Ata from './pages/Atas/Ata';
import Presidente from './pages/Presidente/Presidente';
import Contato from './pages/Contato/Contato';
import Midias from './pages/Midias/Midias';
import Sistema from './pages/Sistemas/Sistema';

function App() {
  return (
    <div className="App">
      <Navbar />
     <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/estatuto' element={<Estatuto />} />
        <Route path='/diretoria' element={<Diretoria />} />
        <Route path='/ata' element={<Ata />} />
        <Route path='/historia' element={<Historia />} />
        <Route path='/presidencia' element={<Presidente />} />
        <Route path='/contato' element={<Contato />} />
        <Route path='/midias' element={<Midias />} />
        <Route path='/sistemasjf' element={<Sistema />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
